import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'video.js/dist/video-js.css';
import JsonCSV from 'vue-json-csv';
import '@fortawesome/fontawesome-free/css/all.css';


import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: 'G-Z1Q07QSKXX' }
})
Vue.component('downloadCsv', JsonCSV)

window.$ = window.jQuery = require('jquery');

Vue.use(BootstrapVue);

import app from './app.vue';

// VUEX - https://vuex.vuejs.org/
import store from './store';

// VUE-ROUTER - https://router.vuejs.org/
import router from './router';

// VUE-MIXIN - https://vuejs.org/v2/guide/mixins.html
import './mixins';

// Set Authentication from store
import { setHeaderTokensFromStore } from './utils/authentication';
setHeaderTokensFromStore();

// Social Media Sharing
import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);

// Vue Analytics (Google Analytics wrapper)
import VueAnalytics from 'vue-analytics';
//and then use it in main.js
Vue.use(VueAnalytics, {
  id: 'UA-237247108-1',
  router,
});

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebookSquare,
  faTwitterSquare,
  faLinkedin,
  faRedditSquare,
} from '@fortawesome/free-brands-svg-icons';

import { faPlay, faPlayCircle, faThumbsUp, faChevronUp, faChevronDown, faChevronLeft, faChevronRight, faCopy } from "@fortawesome/free-solid-svg-icons";
import {
  faLink,
  faBookmark as faBookmarkSolid,
  faCheckCircle,
  faTimesCircle,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faFacebookSquare);
library.add(faTwitterSquare);
library.add(faLinkedin);
library.add(faRedditSquare);
library.add(faLink);
library.add(faBookmarkSolid);
library.add(faBookmark);
library.add(faCheckCircle);
library.add(faTimesCircle);
library.add(faPlay);
library.add(faPlayCircle);
library.add(faThumbsUp)
library.add(faChevronUp);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faCopy);
library.add(faSearch);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg', // default - only for display purposes
  },
});

// Add the Vue component for YouTube
import VueYoutube from 'vue-youtube';
Vue.use(VueYoutube);

new Vue({
  render: (h) => h(app),
  vuetify: new Vuetify(),
  router,
  store,
  el: "#app",
}).$mount('#app');
router.afterEach((to, from) => {
  //document.title = to.meta.title;
});
